import { render, staticRenderFns } from "./arzypto_mobile_application.vue?vue&type=template&id=4025c2bd&"
import script from "./arzypto_mobile_application.vue?vue&type=script&lang=js&"
export * from "./arzypto_mobile_application.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports